module.exports = __webpack_public_path__ + "71ce8efbdba37a1e5369c6b6391ea366.png";